export default __webpack_public_path__ + "static/media/pexels-jorge-fakhouri-filho-2701660-removebg-preview 1.73e2ecd3.png";